import { render, staticRenderFns } from "./FavoritesSelect.vue?vue&type=template&id=7c2dfe4a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./FavoritesSelect.vue?vue&type=script&lang=ts&"
export * from "./FavoritesSelect.vue?vue&type=script&lang=ts&"
import style1 from "./FavoritesSelect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2dfe4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2dfe4a')) {
      api.createRecord('7c2dfe4a', component.options)
    } else {
      api.reload('7c2dfe4a', component.options)
    }
    module.hot.accept("./FavoritesSelect.vue?vue&type=template&id=7c2dfe4a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('7c2dfe4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Favorites/FavoritesSelect.vue"
export default component.exports